import React, { useState } from "react";

export default function AadhaarInput({
  id,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}) {
  const [realValue, setRealValue] = useState("");

  const handleChange = (e) => {
    let entered = e.target.value.replace(/ /g, "");
    let raw = realValue;

    if (entered.length > raw.length) {
      raw += entered.slice(raw.length);
    } else {
      raw = raw.slice(0, entered.length);
    }

    raw = raw.replace(/\D/g, "").slice(0, 12);
    setRealValue(raw);

    // Mask middle 4 digits
    let masked = raw
      .split("")
      .map((digit, i) => (i >= 4 && i < 8 ? "*" : digit))
      .join("")
      .replace(/(.{4})/g, "$1 ")
      .trim();

    // Send masked to parent
    onChange && onChange(masked, raw);

    // Show masked in input
    e.target.value = masked;
  };

  return (
    <div className="relative">
      {/* Orange Aadhaar Icon */}
      <i className="fa fa-id-badge absolute left-3 top-3 text-[#FF702B] text-sm"></i>

      {/* Aadhaar Input */}
      <input
        type="text"
        id={id}
        disabled={disabled}
        placeholder="XXXX XXXX XXXX"
        inputMode="numeric"
        className={`w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400
          focus:outline-none focus:ring-0 focus:border-[#FF702B]
          ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}
          ${error ? "border-red-500" : ""}`}
        value={value || ""}
        onChange={handleChange}
        onBlur={onBlur}
      />
      {error && <span className="error">{error}</span>}
    </div>
  );
}
